exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._197Xt46Pdx-_pE9WTZKLu7{display:inline-flex;align-items:center;justify-content:center;height:15px;padding:0 8px;border-radius:8px;font-size:10px;line-height:15px;white-space:nowrap;text-align:center;background-color:var(--primary-base-color);color:var(--background-color);transition:background-color .3s;margin-left:4px}", ""]);

// Exports
exports.locals = {
	"badge": "_197Xt46Pdx-_pE9WTZKLu7"
};